import dom from "../../../../common/ts/core/dom";
import {EventBus} from "../../../../common/ts/events/EventBus";
import {NextPagePaginatedEvent, PagePaginatedEvent, PreviousPagePaginatedEvent} from "./events";
import eventHandlers from "./eventHandlers";

const NEXT_PAGE_LINK_SELECTOR = '#pagination-next';
const PREVIOUS_PAGE_LINK_SELECTOR = '#pagination-prev';
const PAGE_LINK_SELECTOR = '.js-pagination-page';

const PAGE_NUMBER_ATTRIBUTE = 'data-page';

function init(ev: any = EventBus.getInstance()) {
    eventHandlers.init();
    const eventBus: EventBus = ev;

    eventBus.emit(new dom.AddClickListenerEvent({
        selector: NEXT_PAGE_LINK_SELECTOR,
        listener: () => eventBus.emit(new NextPagePaginatedEvent()),
    }));

    eventBus.emit(new dom.AddClickListenerEvent({
        selector: PREVIOUS_PAGE_LINK_SELECTOR,
        listener: () => eventBus.emit(new PreviousPagePaginatedEvent()),
    }));

    eventBus.emit(new dom.AddClickListenerEvent({
        selector: PAGE_LINK_SELECTOR,
        listener: function pagePaginatedClickEventListener(this: HTMLElement) {
            const pageNumber = this.getAttribute(PAGE_NUMBER_ATTRIBUTE)
            eventBus.emit(
                new PagePaginatedEvent({ pageNumber })
            );
        },
    }));
}

export default {
    init,
}